import { InlineMessage } from '@strata/react-inline-message';

import { Columns } from 'components/shared/Columns';
import { Page } from 'components/shared/Page';
import { Section } from 'components/shared/Section';

const brandOwnership = [
    <p key="1">
        This page features Free Market Health&#39;s brand ownership values. They are deep beliefs
        about what&#39;s most important. They shape our thoughts, our actions and the way we work
        with others. In a sense, they make us who we are.
    </p>,
    <InlineMessage
        key="2"
        wrapText
        intent={InlineMessage.Intent.TIP}
        title="Good time to express the values"
        label={
            <ul>
                <li>Onboarding or training</li>
                <li>In company overview materials</li>
            </ul>
        }
    />,
    <div key="3">
        <div className="sds_section__callout__title">Empower</div>
        <div className="sds_section__callout__description">
            To invest with power, to equip or supply with an ability
        </div>
    </div>,
    <Columns
        key="4"
        columns={Columns.ColumnNumber.TWO}
        content={
            <>
                <div>
                    <h4>Access</h4>
                    <p>
                        We know that a truly empowering system is one that everybody can enter. So
                        we enhanced the marketplace to remove barriers, freeing specialty pharmacies
                        to see more, and more appropriate, referrals, and payers to reach the
                        pharmacies best-suited for their members.
                    </p>
                </div>
                <div>
                    <h4>Fairness</h4>
                    <p>
                        We know that a $250B market requires specialty pharmacies of all sizes and
                        scopes to meet a complex array of patient needs. We&#39;ve built a platform
                        that allows them all to play to their strengths, focusing on the kinds of
                        referrals they can best fill, and the patients they can best serve.
                    </p>
                </div>
                <div>
                    <h4>Visibility</h4>
                    <p>
                        We believe in the power of information. That&#39;s why we leverage our deep
                        technology experience to enable the kind of transparency that can enhance
                        business and care, and give both specialty pharmacies and payers the ability
                        to make better-informed decisions.
                    </p>
                </div>
                <div>
                    <h4>Tenacity</h4>
                    <p>
                        We&#39;re an organization with deep pharmacy and health care experience.
                        We&#39;ve seen firsthand the value to patients of a smoothly functioning
                        referral and fulfillment system—and we know where the current system falls
                        short. That&#39;s why we work tirelessly to ensure that the process never
                        fails the patient.
                    </p>
                </div>
            </>
        }
    />,
];

const positioningStatement = [
    <p key="5">
        A positioning statement adds detail and explains the qualities that differentiate a company
        and how it adds value.
    </p>,
    <InlineMessage
        key="6"
        wrapText
        intent={InlineMessage.Intent.TIP}
        title="Good time to use the positioning statement"
        label="When you describe the company in business focused materials (i.e., not patient focused)"
    />,
    <p key="7">
        For forward-thinking payers and specialty pharmacies of all sizes who need to operate in a
        complex and opaque market, Free Market Health opens up a dynamic, care-driven platform that
        empowers all stakeholders to optimize resources and maximize opportunities—with the goal of
        balancing the cost of care and the value that care provides.
    </p>,
    <div key="8">
        <h3>Positioning Key Takeaways</h3>
        <h4>What we&#39;re doing</h4>
        <p>Empowering Payers & Pharmacies</p>
    </div>,
    <div key="9">
        <h4>How we&#39;re doing it</h4>
        <p>Creating a Care-Driven Marketplace</p>
    </div>,
];

export const DefiningOurBrand = () => (
    <div>
        <Page
            pageTitle="Defining Our Brand"
            pageDescription="Outlines the building blocks of our brand, including what sets us apart."
            pageContent={
                <>
                    <Section title="Brand Ownership" contentArray={brandOwnership} />
                    <Section title="Positioning Statement" contentArray={positioningStatement} />
                </>
            }
        />
    </div>
);
